import { PeriodComparisonValue } from '../../../types/periodComparisonValue'

const supportedModes = ['month', 'quarter', 'year', 'period'] as const
type SupportedMode = (typeof supportedModes)[number]

export const isSupportedMode = (mode: PeriodComparisonValue): mode is SupportedMode => {
  return supportedModes.includes(mode as SupportedMode)
}
